const switchFontSize = document.querySelector('.switch--font');
const currentFontSize = window.localStorage.getItem('data-fontsize');

currentFontSize
    ? document.documentElement.setAttribute('data-fontsize', currentFontSize)
    : document.documentElement.setAttribute('data-fontsize', 0);

if (switchFontSize) {
    switchFontSize.addEventListener('click', () => {
        let counter = Number(document.documentElement.dataset.fontsize);
        counter === 2 ? (counter = 0) : counter++;
        document.documentElement.setAttribute('data-fontsize', counter);
        window.localStorage.setItem('data-fontsize', counter);
    });
}
